export default __webpack_public_path__ + "a376508af43be881f61c9a75442524c9.svg";